<template>
    <div class="flex-row align-items-center register">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="4">
                    <b-card no-body class="p-2">
                        <b-card-body>
                            <h2 class="mb-4">Register</h2>
                            <b-alert :show="error !=null" variant="danger">
                                {{error}}
                            </b-alert>
                            <b-form @submit="login()" v-if="!registered">
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <font-awesome-icon :icon="['far', 'user']" />
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" placeholder="First Name" v-model="first_name" :state="(typeof errors['first_name'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['first_name']}}
                                    </b-form-invalid-feedback>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <font-awesome-icon :icon="['far', 'user']" />
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Last Name" v-model="last_name" :state="(typeof errors['last_name'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['last_name']}}
                                    </b-form-invalid-feedback>
                                </b-input-group>

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <font-awesome-icon :icon="['far', 'envelope']" />
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Email" v-model="email" :state="(typeof errors['email'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['email']}}
                                    </b-form-invalid-feedback>
                                </b-input-group>

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <font-awesome-icon :icon="['far', 'building']" />
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Company" v-model="company_name"></b-form-input>
                                </b-input-group>

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-lock"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="password" class="form-control" placeholder="Password" v-model="password" :state="(typeof errors['password'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['password']}}
                                    </b-form-invalid-feedback>
                                </b-input-group>

                                <b-input-group class="mb-4">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-lock"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="password" class="form-control" placeholder="Confirm Password" v-model="password_confirm" :state="(typeof errors['password_confirm'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['password_confirm']}}
                                    </b-form-invalid-feedback>
                                </b-input-group>

                                <b-button block variant="primary" class="px-4 mb-2" @click="create">Create Account</b-button>

                            </b-form>

                            <b-row class="links" v-if="!registered">
                                <b-col class="text-center">
                                    <router-link :to="{name: 'login', query: $route.query}">Sign in instead</router-link>
                                </b-col>
                            </b-row>

                            <b-row v-if="registered">
                                <b-col>
                                    <p>Thanks for registering!</p>

                                    <p>Check your email to verify your account and login.</p>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            password_confirm: '',
            company_name: '',
            errors: {},
            error: null,
            submitted: false,
            registered: false,
        }
    },

    methods: {
        create () {
            if (!this.email || !this.password) {
                this.error = 'Missing your email or password'
                return
            }

            let data = {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                company_name: this.company_name,
                password: this.password,
                password_confirm: this.password_confirm,
                provider_id: (window.Provider) ? window.Provider.id : 1,
                system_refer: 'ecom'
            }

            this.errors = {}
            this.error = null

            this.axios.post(window.location.protocol + '//' + window.location.host + '/register', data)
                .then(res => {
                    this.registered = true
                })
                .catch(err => {
                    this.error = 'There was an error creating the account'
                    for (var field in err.response.data.errors) {
                        this.errors[field] = err.response.data.errors[field][0]
                    }
                });
        }
    }
}
</script>



// WEBPACK FOOTER //
// prompts/views/pages/Register.vue